import './Footer.css';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

const Footer = () => {

    const history = useHistory();

    const isLoggedIn = localStorage.getItem("sessionId")

    const handleLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem("sessionId");
        localStorage.removeItem("userId");
        localStorage.removeItem("userFullName");
        localStorage.removeItem("userAddress")
        localStorage.removeItem("userEmailAddress")
        localStorage.removeItem("userMobilePhone")
        Swal.fire({
            title: "Logout berhasil!",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500
        });
        history.push("/app");
        history.goBack();
    }

    return (
        <>
            <div className="footer-main-wrapper">
                <div className="footer-wrapper">
                    <div className="footer-markopedia footer-flex">
                        <h4 className="footer-title">Markopedia</h4>
                        <h4 className="footer-links">Pogung Baru</h4>
                        <h4 className="footer-links">Yogyakarta, Indonesia</h4>
                        <h4 className="footer-links">markopedia.volveteam.com</h4>
                    </div>
                    <div className="footer-shop footer-flex">
                        <h4 className="footer-title">Toko</h4>
                        <h4 className="footer-links">Produk Lokal</h4>
                        <h4 className="footer-links">Elektronik</h4>
                        <h4 className="footer-links">Olaharaga</h4>
                        <h4 className="footer-links">Pakaian</h4>
                        <h4 className="footer-links">Properti</h4>
                    </div>
                    <div className="footer-customersupport footer-flex">
                        <h4 className="footer-title">Dukungan Pelanggan</h4>
                        <h4 className="footer-links">Kontak Kami</h4>
                        <h4 className="footer-links">Pusat Layanan Pelanggan</h4>
                        <h4 className="footer-links">Tentang Kami</h4>
                    </div>
                    <div className="footer-policy footer-flex">
                        <h4 className="footer-title">Kebijakan</h4>
                        <h4 className="footer-links">Syarat & Ketentuan</h4>
                        <h4 className="footer-links">Metode Pembayaran</h4>
                        <h4 className="footer-links">FAQ</h4>
                    </div>
                </div>
            </div>
            <div className="copyright-footer">
                <h4>&copy;2021 by Tolbu Corp •  {isLoggedIn ?
                    <span onClick={handleLogout}>Keluar</span> : null}
                </h4>
            </div>

        </>
    )
};

export default Footer;